import { render } from "./PricingSection.vue?vue&type=template&id=25f375e6&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=ts"
export * from "./PricingSection.vue?vue&type=script&lang=ts"

import "./PricingSection.vue?vue&type=style&index=0&id=25f375e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25f375e6"

export default script